import { Button, Layout, Space, Tooltip } from "antd";
import styles from "./sell.module.less";
import i18n, { languageKeys } from "../../../../i18n";
import { useEventListener } from "hooks";
import { apis } from "../../../../constants";

const FooterSell = ({ pdfRef, receiptsList, handleSubmitPayment, checkPermission }) => {

  const handlePrintAll = () => {
    pdfRef.current.openModal(
      { arr_PHIEU_BAN_VAT_TU_ID: receiptsList.flatMap(i => i.ID) },
      apis.layDataNhieuHoaDonBanVatTu
    )
  }

  const keydownEvent = (event) => {
    const stopDefault = () => {
      event.stopPropagation();
      event.preventDefault();
    }
    if (receiptsList.every(i => i.TRANG_THAI_THANH_TOAN)) {
      if (event.ctrlKey && event.key === "i" && checkPermission.IN) {
        stopDefault()
        handlePrintAll()
      }
    } else {
      if (event.ctrlKey && event.key === "b" && checkPermission.DUYET && checkPermission.IN) {
        stopDefault()
        handleSubmitPayment(true)
      }
      if (event.ctrlKey && event.key === "p" && checkPermission.DUYET) {
        stopDefault()
        handleSubmitPayment(false)
      }
    }
  };
  useEventListener("keydown", keydownEvent, window.document, true);

  return (
    <Layout.Footer className={styles.footer}>
      {!receiptsList.every(i => i.TRANG_THAI_THANH_TOAN)
        ? (
          <Space>
            <Tooltip>
              <Button
                type="primary"
                onClick={() => handleSubmitPayment(true)}
                disabled={!checkPermission.DUYET || !checkPermission.IN}
              >
                {i18n.t(languageKeys.vien_phi_thanh_toan_va_in)} (Ctrl+B)
              </Button>
            </Tooltip>
            <Tooltip>
              <Button
                type="primary"
                onClick={() => handleSubmitPayment(false)}
                disabled={!checkPermission.DUYET}
              >
                {i18n.t(languageKeys.field_Thanh_toan)} (Ctrl+P)
              </Button>
            </Tooltip>
          </Space>
        )
        : (
          <Space>
            <Tooltip>
              <Button
                type="primary"
                onClick={handlePrintAll}
                disabled={!checkPermission.IN}
              >
                {i18n.t(languageKeys.print_all)} (Ctrl+I)
              </Button>
            </Tooltip>
          </Space>
        )}
    </Layout.Footer>
  )
}

export default FooterSell;